module.exports = __webpack_public_path__ + "media/idle.67af59b5.mp4";